import React from "react";
import App from "./app";
import { Constants } from "./constants";
import { BrowserRouter } from "react-router-dom";

export default function Root(props) {
  return (
    <BrowserRouter basename={Constants.ROUTES.BASE_URL}>
      <App name={props.name} />
    </BrowserRouter>
  );
}
